//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {copyToClipboard} from 'quasar'
import InventoryHandler from '@/mixins/InventoryHandler.js'
export default {
    data() {
        return {
            showRules: true,
            isLoading: true,
            newsModal: true,
            whatsappNo: '60657225',
            cart: [],
            total: 0,
            seamless: true,
            cartDialog: false,
            studentName: '',
            comments: '',
            selectedPickupMethod: '',
            selectedPaymentMethod: 'Yappy',
            pickupMethods: [
                {label: 'Segundo recreo', value: 'Segundo recreo'},
                {label: 'Salida', value: 'Salida'},
            ],
            paymentMethods: [
                {
                    label: 'Yappy',
                    value: 'Yappy',
                },
                {label: 'ACH', value: 'ACH'},
            ],
            menu: [],
        }
    },
    methods: {
        addToCart(item) {
            let today = new Date()
            let todayDay = today.getDay()
            let todayHour = today.getHours()
            if (
                (todayDay > 0 || todayDay <= 5) &&
                todayHour >= 10 &&
                todayHour <= 14
            ) {
                this.$q.notify({
                    message:
                        'Lo sentimos, el horario de pedidos no esta disponible de 10am a 3pm.',
                    color: 'red-7',
                    icon: 'error',
                    position: 'top',
                    progress: true,
                    classes: 'text-bold',
                    timeout: 3000,
                })
                return
            }
            if (this.cart.find(el => el.id == item.id)) {
                this.cart.find(el => {
                    if (el.id == item.id) item.amount++
                })
            } else {
                item.amount = 1
                this.cart.push(item)
            }
            this.calculateTotal()
        },
        removeFromCart(index) {
            this.cart.splice(index, 1)
            this.calculateTotal()
            if (!this.cart.length) this.cartDialog = false
        },
        calculateTotal() {
            this.total = 0
            this.cart.forEach(item => {
                this.total += item.amount * item.price
            })
        },
        showToday(itemDay) {
            let today = new Date()
            let todayDay = today.getDay()
            let todayHour = today.getHours()
            if (todayDay == 5 && todayHour >= 15 && itemDay == 1) return true
            if ((todayDay > 5 || todayDay < 1) && itemDay == 1) return true
            if (itemDay == todayDay && todayHour < 15) return true
            if (itemDay < todayDay) return false
            if (itemDay == todayDay + 1 && todayHour >= 15) return true
        },
        hideIfInThePast(itemDay) {
            let today = new Date()
            let todayDay = today.getDay()
            let todayHour = today.getHours()
            // todayDay = 2
            // todayHour = 16
            if (todayDay == 6 || todayDay == 0) return true
            if (todayDay == 5 && todayHour >= 15) return true
            if (itemDay == todayDay && todayHour >= 15) return false
            if (itemDay >= todayDay) return true
            else return false
        },
        generateWhatsappMessage() {
            // let message =
            //     'Buenas me gustaria realizar un pedido de:%0D%0A%0D%0A'
            let message = ''
            message += `Orden No. ${this.generateOrderNo(4)}%0D%0A%0D%0A`
            this.cart.forEach(item => {
                message += `(${item.amount}) - ${item.name}%0D%0A`
            })
            message += `%0D%0ANombre: ${this.studentName}`
            message += `%0D%0AEntrega: ${this.selectedPickupMethod}`
            // message += `%0D%0AMetodo de pago: ${this.selectedPaymentMethod}`
            message += `%0D%0ATotal: $${this.total.toFixed(2)}`
            if (this.comments)
                message += `%0D%0A%0D%0AComentarios: ${this.comments}`
            message = message.replace(/\+/g, '%2B')
            message = message.replace(/&/g, '%26')
            message = message.replace(/#/g, '%23')
            return message
        },
        sendOrder() {
            if (
                !this.studentName ||
                !this.selectedPickupMethod ||
                !this.selectedPaymentMethod
            ) {
                let errors = []
                let errMsg = 'Debes llenar los siguientes campos: '
                if (!this.studentName) errors.push('Nombre')
                if (!this.selectedPickupMethod) errors.push('Entrega')
                if (!this.selectedPaymentMethod) errors.push('Metodo de pago')
                for (let i = 0; i < errors.length; i++) {
                    errMsg += errors[i]
                    if (i < errors.length - 1) errMsg += ', '
                }
                this.$q.notify({
                    message: errMsg,
                    color: 'red-7',
                    icon: 'error',
                    position: 'top',
                    progress: true,
                    classes: 'text-bold',
                    timeout: 3000,
                })
                return
            }
            window.location.href = `https://wa.me/507${
                this.whatsappNo
            }?text=${this.generateWhatsappMessage()}`
        },
        copyToClipboard(text) {
            copyToClipboard(text)
                .then(() => {
                    this.$q.notify({
                        message: `${this.selectedPaymentMethod} copiado con exito`,
                        color: 'lasalle-yellow',
                        icon: 'check',
                        badgeColor: 'lasalle-blue',
                        progress: true,
                        classes: 'poppins-bold',
                        timeout: 1000,
                        position: 'top',
                    })
                })
                .catch(() => {
                    // fail
                })
        },
        generateOrderNo(length) {
            // let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
            let chars = '0123456789'
            let code = ''
            for (let i = 0; i < length; i++) {
                let min = Math.ceil(0)
                let max = Math.floor(chars.length)
                let index = Math.floor(Math.random() * (max - min) + min)
                code += chars[index]
            }
            return code
        },
        returnDayNameByNumber(day) {
            if (day == 1) return 'Lunes'
            if (day == 2) return 'Martes'
            if (day == 3) return 'Miercoles'
            if (day == 4) return 'Jueves'
            if (day == 5) return 'Viernes'
        },
    },
    computed: {
        showSeamless() {
            if (this.cart.length) return true
        },
        returnDayName() {
            let today = new Date()
            let todayDay = today.getDay()
            let todayHour = today.getHours()
            if (todayDay == 1 && todayHour < 15) return 'Lunes'
            if (todayDay == 1 && todayHour >= 15) return 'Martes'
            if (todayDay == 2 && todayHour < 15) return 'Martes'
            if (todayDay == 2 && todayHour >= 15) return 'Miercoles'
            if (todayDay == 3 && todayHour < 15) return 'Miercoles'
            if (todayDay == 3 && todayHour >= 15) return 'Jueves'
            if (todayDay == 4 && todayHour < 15) return 'Jueves'
            if (todayDay == 4 && todayHour >= 15) return 'Viernes'
            if (todayDay == 5 && todayHour < 15) return 'Viernes'
            if (todayDay == 5 && todayHour >= 15) return 'Lunes'
            if (todayDay > 5 || todayDay < 1) return 'Lunes'
        },
    },
    mixins: [InventoryHandler],

    async mounted() {
        this.generateOrderNo(4)
        this.menu = await this.getInventoryItems()
        let id = 0
        this.menu.forEach(item => {
            item.id = id
            id++
        })
        this.isLoading = false
    },
}
